// extracted by mini-css-extract-plugin
export var userSelectNone = "FmPNN";